import { LocalStorageKey } from './constants'

export const getCurrentRoleRoute = (): string | null => {
  const authDataFromStorage = localStorage.getItem(LocalStorageKey.auth)
  if (!authDataFromStorage) return null

  const authData = JSON.parse(authDataFromStorage)
  return authData.account.role.toLowerCase()
}
